import React, { useCallback, useContext, useMemo } from 'react'
import BedbankCancellationPolicyModal from './BedbankCancellationPolicyModal'
import { getPromotionCancellationPolicyByCode } from '@luxuryescapes/lib-refunds/build'
import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { pluralizeToString } from 'lib/string/pluralize'
import ModalContext from 'contexts/ModalContext'
import Group from 'components/utils/Group'

interface Props {
  policyCode: string
}

function BedbankCancellationPolicy(props: Props) {
  const { policyCode } = props
  const showModal = useContext(ModalContext)

  const policyNumberOfDays = getPromotionCancellationPolicyByCode(policyCode)?.numberOfDays ?? 0

  const policyTitle = useMemo(() => {
    return policyCode === 'non-refundable' ? 'Non-refundable' : 'Free Cancellation'
  }, [policyCode])

  const policyDescription = useMemo(() => {
    if (policyCode === 'non-refundable') {
      return 'If you cancel your booking, you are not eligible for a refund or credit for a future stay.'
    } else {
      return `Accommodation bookings can be cancelled with a full refund provided the cancellation is made no less than ${pluralizeToString('day', policyNumberOfDays)} prior to check-in.` +
        ` That is cancel by 11:59 pm (local time of property), ${pluralizeToString('day', policyNumberOfDays)} prior to the day of check-in. Excludes flights.`
    }
  }, [policyNumberOfDays, policyCode])

  const showPolicy = useCallback(() => {
    showModal(<BedbankCancellationPolicyModal heading={policyTitle} policyDescriptions={[policyDescription]} />)
  }, [policyTitle, policyDescription, showModal])

  return <Clickable onClick={showPolicy}>
    <Group direction="horizontal" gap={4} verticalAlign="center">
      <BodyText variant="medium" wrap="no-wrap" weight="bold" colour={policyCode !== 'non-refundable' ? 'highlight-secondary' : undefined}>{policyTitle}</BodyText>
      <LineInfoCircleIcon colour="success" size="XS" />
    </Group>
  </Clickable>
}

export default BedbankCancellationPolicy
